<template>
  <!-- An error toast's text: the toaster announces politely, an error has to interrupt. -->
  <span role="alert" v-text="text" />
</template>

<script setup>
defineProps({
  text: {
    type: String,
    required: true,
  },
})
</script>
